import { styled } from '@mui/material';
import { ContentWrapper } from '../../../styles/shared';
import { Companies } from '../../../models/domain/enum';
import { getCompany } from '../../../utils/company';

export const StyledContentWrapper = styled(ContentWrapper)(() => ({}));

export const Container = styled('div')(({ theme, keepSpace }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacings.unit(40 / 4),
  paddingBottom: theme.spacings.unit(48 / 4),
  [theme.breakpointsMediaQuery.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  [theme.breakpointsMediaQuery.down('sm')]: {
    flexDirection: 'row',
    paddingTop: keepSpace
      ? theme.spacings.unit(40 / 4)
      : theme.spacings.unit(10 / 4),
  },
}));

export const Left = styled('div')(({ theme }) => ({
  position: 'sticky',
  maxWidth: '15%',
  minWidth: theme.spacings.unit(240 / 4),
  paddingRight: theme.spacings.unit(8),
  top: theme.spacings.unit(240 / 4),
  [theme.breakpointsMediaQuery.up('lg')]: {
    ...(() => {
      switch (getCompany()) {
        case Companies.SIRMAN:
          return {
            top: theme.spacings.unit(240 / 4),
          };
        case Companies.FELSINEA:
          return {
            top: theme.spacings.unit(180 / 4),
          };
      }
      return {};
    })(),
  },

  [theme.breakpointsMediaQuery.down('lg')]: {
    top: theme.spacings.unit(70 / 4),
  },
}));

export const Main = styled('div', {
  shouldForwardProp: (prop) => !['full'].includes(prop as string),
})(({ theme, full }) => ({
  width: full === 'true' ? '100%' : '85%',
  [theme.breakpointsMediaQuery.down('md')]: {
    width: '100%',
  },
}));

export const TitleMain = styled('h2')(({ theme, noSpace }) => ({
  margin: '0px',
  fontWeight: '500',
  marginBottom: noSpace ? 0 : theme.spacings.unit(16 / 4),
  paddingRight: theme.spacings.unit(8 / 4),
  [theme.breakpointsMediaQuery.up('md')]: {
    textAlign: 'start',
  },
}));

export const MainRepeater = styled('div')(({ theme }) => ({
  marginBottom: '2rem',
}));

export const Label = styled('label')(({ theme }) => ({
  marginRight: '0',
}));

export const MainPagination = styled('div')(({ theme }) => ({
  marginBottom: '2rem',
  display: 'flex',
  flexAlign: 'center',
  justifyContent: 'space-between',
  [theme.breakpointsMediaQuery.down('md')]: {
    width: '100%',
    justifyContent: 'center',
  },
}));

export const SeoText = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.colors.drawerDivider}`,
  paddingTop: '2rem',
}));

export const Results = styled('p')(({ theme }) => ({
  fontSize: theme.fonts.utility.size(7),
  letterSpacing: theme.spacings.unit(0.7 / 4),
  color: theme.colors.modalSecondaryText,
  textAlign: 'left',
  margin: `${theme.spacings.unit(20 / 4)} 0`,
  [theme.breakpointsMediaQuery.down('lg')]: {
    margin: `${theme.spacings.unit(30 / 4)} 0`,
  },
}));

export const Tags = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacings.unit(4),
  [theme.breakpointsMediaQuery.down('lg')]: {
    marginTop: theme.spacings.unit(4),
  },
  [theme.breakpointsMediaQuery.up('md')]: {
    marginBottom: theme.spacings.unit(4),
  },
}));

export const Tag = styled((props: any) => {
  return !props.disabled ? <a {...props} /> : <span {...props} />;
})(({ theme, disabled }) => ({
  border: `${theme.spacings.unit(1 / 4)} solid ${theme.colors.primary}`,
  fontSize: theme.fonts.utility.size(7),
  color: theme.colors.primary,
  margin: 0,
  padding: theme.spacings.unit(1),
  fontWeight: 'bold',
  [theme.breakpointsMediaQuery.down('lg')]: {
    flexGrow: 1,
  },
  textAlign: 'center',
  cursor: disabled ? 'default' : 'pointer',
  transitionDuration: '0.2s',
  textDecoration: 'none',

  '&:hover': {
    color: disabled ? theme.colors.primary : theme.colors.background,
    backgroundColor: disabled ? theme.colors.background : theme.colors.primary,
  },
}));

export const InfoGenericWrapperStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
}));

export const TitleWithSortingWrapperStyled = styled('div')(() => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
}));

export const MarkdownWrapper = styled('div')(({ theme }) => ({
  marginBottom: theme.spacings.unit(32 / 4),
  [theme.breakpointsMediaQuery.down('md')]: {
    marginTop: theme.spacings.unit(16 / 4),
  },
}));
